import React, { useEffect, useState } from 'react';

import { useHistory, useParams } from 'react-router-dom';

import axios from '../../services/MyAxios';

import AffiliateOwnerForm from './AffiliateOwnerForm';

import Card from 'crm/elements/common/Card';

function AffiliateOwnerEdit() {
    const { id } = useParams();
    const [affiliateOwner, setAffiliateOwner] = useState();
    const [errors, setErrors] = useState([]);
    const history = useHistory();
    const url = `/crea/api/affiliate_owner/${id}`;

    useEffect(() => {
        getAffiliateOwner();
    }, []);

    function getAffiliateOwner() {
        axios.get(url).then((response) => {
            setAffiliateOwner(response.data);
        });
    }

    const handleEditAffiliateOwner = (newAffiliateOwner) => {
        axios
            .patch(url, newAffiliateOwner)
            .then((response) => {
                setAffiliateOwner(response.data);
                history.push('/affiliate_owners');
            })
            .catch((error) => {
                setErrors(error.response.data.errors);
            });
    };

    return (
        <Card title="Update Affiliate Owner">
            <AffiliateOwnerForm action={handleEditAffiliateOwner} errors={errors} affiliateOwnerData={affiliateOwner} />
        </Card>
    );
}

export default AffiliateOwnerEdit;
